import { ClaimNumberSchema } from '@eigtech/claims-v2-types';
import { z } from 'zod';
import { ImportStatusesSchema } from './importStatus.js';
export const XaAssignmentImportStatusApiSchema = {
    query: z.object({
        claimNumber: ClaimNumberSchema,
    }),
    response: z.record(ClaimNumberSchema, ImportStatusesSchema),
};
